import { Box } from '@mui/material'
import React from 'react'
import AppBar from '@mui/material/AppBar'
import { styled } from '@mui/material/styles'
import { footerConfigObject } from '../../config'
import { TChildElementProps } from '../../types'
import { useLayoutContext } from '../../Context/LayoutContext'

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.text.primary,
}))

export const FooterLayoutBox = ({ children }: TChildElementProps) => {
  //   const isMobileLayout = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  //   const isDesktopLayout = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'))
  const layoutSelected = useLayoutContext() as keyof typeof footerConfigObject
  const selectedLayout = footerConfigObject[layoutSelected]
  return (
    <StyledAppBar sx={{ p: '0.5rem' }} position='static'>
      <Box
        sx={{
          display: 'grid',
          justifyContent: 'end',
          gridTemplateColumns: selectedLayout.gridTemplateColumns,
          gridTemplateRows: selectedLayout.gridTemplateRows,
          columnGap: selectedLayout.gap,
          gridTemplateAreas: selectedLayout.gridTemplateAreas,
        }}
      >
        {children}
      </Box>
    </StyledAppBar>
  )
}
